import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import MultiTagInput from "../../component/MultiTagInput/MultiTagInput";
import { getToken } from "../../../../helpers/Jwt";
import FormatTransaction from "../../component/FormatTransaction/FormatTransaction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGears } from "@fortawesome/free-solid-svg-icons";
import InputOption from "../../component/InputOption/InputOption";
import OutstandingComponent from "./component/OutstandingComponent";

const EntryPurchasesPayment = () => {
  const { supplier } = useParams();

  const navigate = useNavigate();
  const [cashbank, setCashBank] = useState([]);
  const [supplierDetail, setSupplierDetail] = useState([]);

  const [remainingBill, setRemainingBill] = useState(0);

  const [paymentData, setPaymentData] = useState([]);
  const [isFormatTransactionOpen, setFormatTransactionOpen] = useState(false);

  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_PAYMENT = "api/erpppsu/purchases/payment";
  const PATH_CONTACT_SUPPLIER = "api/erpppsu/contact/detail";
  const PATH_ACCOUNT_CASH_BANK = "api/erpppsu/account/cashbank";

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    }
  };

  const calculateRemainingBill = () => {
    const totalBill = 0;
    const remaining = totalBill;
    setRemainingBill(remaining > 0 ? remaining : 0);
  };

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_CONTACT_SUPPLIER}?id=${supplier}`,).then((data) => {
      setSupplierDetail(data);
    });

    fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}`,).then((data) => {
      setCashBank(data);
    });
  }, []);

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        ...values,
        subtotal: subtotal,
        amount: total,
        idSupplier: supplier,
        no_transaction: values.no_transaction,
        selectedTags,
        paymentData
      };

      await axios.post(`${BASE_URL}${PATH_PAYMENT}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });

      navigate('/activity-erpppsu/purchases');
    } catch (error) {
      alert(error.response.data);
      console.error('Error submitting form:', error);
    } finally {
      setSubmitting(false);
    }
  };

  // Formik initial values
  const initialValues = {
  };

  // Validation schema (using Yup)
  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const handlePaymentUpdate = (data) => {
    setPaymentData(data);
  };

  return (
    <div className="mx-auto p-4">
      <div className='flex items-center justify-between px-5'>
        <h2 className="text-2xl font-bold mb-4">
          Lakukan Pembayaran
        </h2>

        <div className='flex items-center'>
        </div>
      </div>

      {/* Formik Form */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div className="container m-auto p-4">
              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                <div className="p-3">
                  <label htmlFor="supplier" className="mb-1 text-sm font-semibold">
                    Supplier
                  </label>   
                  <p>{supplierDetail?.display_name}</p>               
                </div>

                <div className="p-3">
                  <label htmlFor="source_cashbank" className="mb-1 text-sm font-semibold">Sumber Dana</label>
                  <InputOption
                    label="Pilih Data"
                    data={cashbank}
                    placeholder="Ketik disini"
                    onChange={(value) => {
                      setFieldValue(`source_cashbank`, value);
                    }} />                    
                </div>
                <div></div>

                <div className="p-3">
                  <h1>Total Rp{subtotal.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                </div>

                
                <div className="">
                  <div className="p-3">
                    <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl. Transaksi</label>
                    <Field
                      type='date'
                      name="date"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                  </div>

                  <div className="p-3">                    
                  </div>

                  <div className="p-3">

                  </div>
                </div>

                <div className="">
                  <div className="p-3">
                    <FormatTransaction
                      show={isFormatTransactionOpen}
                      onClose={() => setFormatTransactionOpen(false)}
                      apply={(value) => {
                        setFieldValue('no_transaction', value);
                      }} />

                    <label htmlFor="no_transaction" className="mb-1 text-sm font-semibold">
                      No. Transaksi&nbsp;
                      <button type="button" onClick={() => setFormatTransactionOpen(true)}>
                        <FontAwesomeIcon icon={faGears} />
                      </button>
                    </label>
                    <Field
                      name="no_transaction"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <ErrorMessage name="no_transaction" component="p" className="text-red-500 text-xs mt-1" />
                  </div>

                  <div className="p-3">
                  </div>

                  <div className="p-3">
                  </div>
                </div>

                <div className="p-3">
                  <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                </div>
              </div>

              <OutstandingComponent
                idSupplier={supplier}
                onDataUpdated={handlePaymentUpdate}
                onSubtotalUpdated={(value) => {
                  setSubtotal(value)
                }} />

              <div className="container m-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                <div className="">
                  <div className="p-3">
                    <label htmlFor="notes" className="mb-1 text-sm font-semibold">Pesan</label>
                    <Field
                      as="textarea"
                      name="notes"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                  </div>
                  {/* <div className="p-3">
                    <label htmlFor="memo" className="mb-1 text-sm font-semibold">Memo</label>
                    <Field
                      as="textarea"
                      name="memo"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                  </div> */}
                </div>
                <div></div>

                <div className='col-span-2'>
                  <div className="max-w-xl mx-auto mt-8 rounded-lg px-5">
                    <div className="flex items-center justify-between mb-6">
                      <h1 className="text-lg font-semibold">Subtotal</h1>
                      <h1 className="text-lg font-semibold">Rp{subtotal.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                    </div>
                  </div>
                  <div className="max-w-xl mx-auto mt-8 rounded-lg px-5">
                    <div className="flex items-center justify-end mt-5">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                          }`}
                      >
                        {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  );
};

export default EntryPurchasesPayment;
